import React from "react";

interface IDiskIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const DiskIcon: React.FC<IDiskIconProps> = ({ sizeX = 25, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.5 21V14C17.5 13.7348 17.3946 13.4804 17.2071 13.2929C17.0196 13.1054 16.7652 13 16.5 13H8.5C8.23478 13 7.98043 13.1054 7.79289 13.2929C7.60536 13.4804 7.5 13.7348 7.5 14V21M7.5 3V7C7.5 7.26522 7.60536 7.51957 7.79289 7.70711C7.98043 7.89464 8.23478 8 8.5 8H15.5M15.7 3C16.2275 3.00751 16.7307 3.22317 17.1 3.6L20.9 7.4C21.2768 7.76926 21.4925 8.27246 21.5 8.8V19C21.5 19.5304 21.2893 20.0391 20.9142 20.4142C20.5391 20.7893 20.0304 21 19.5 21H5.5C4.96957 21 4.46086 20.7893 4.08579 20.4142C3.71071 20.0391 3.5 19.5304 3.5 19V5C3.5 4.46957 3.71071 3.96086 4.08579 3.58579C4.46086 3.21071 4.96957 3 5.5 3H15.7Z"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
